var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContourFinding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #78A9FF;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.7,4.7a14.7029,14.7029,0,0,0-3,3.1L6.3,9A13.2634,13.2634,0,0,1,8.9,6.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.6,12.3l-1.9-.6A12.5111,12.5111,0,0,0,2,16H4A11.4756,11.4756,0,0,1,4.6,12.3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.7,20.4a14.4029,14.4029,0,0,0,2,3.9l1.6-1.2a12.8867,12.8867,0,0,1-1.7-3.3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.8,27.3a14.4029,14.4029,0,0,0,3.9,2l.6-1.9A12.8867,12.8867,0,0,1,9,25.7Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.7,2.7l.6,1.9A11.4756,11.4756,0,0,1,16,4V2A12.5111,12.5111,0,0,0,11.7,2.7Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.2,27.3a15.18,15.18,0,0,0,3.1-3.1L25.7,23A11.526,11.526,0,0,1,23,25.7Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.4,19.7l1.9.6A15.4747,15.4747,0,0,0,30,16H28A11.4756,11.4756,0,0,1,27.4,19.7Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.2,11.6a14.4029,14.4029,0,0,0-2-3.9L25.6,8.9a12.8867,12.8867,0,0,1,1.7,3.3Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.1,4.6a14.4029,14.4029,0,0,0-3.9-2l-.6,1.9a12.8867,12.8867,0,0,1,3.3,1.7Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.3,29.3l-.6-1.9A11.4756,11.4756,0,0,1,16,28v2A21.4206,21.4206,0,0,0,20.3,29.3Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,26A10,10,0,1,1,26,16,10.0115,10.0115,0,0,1,16,26ZM16,8a8,8,0,1,0,8,8A8.0092,8.0092,0,0,0,16,8Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle",
    "data-name": " Transparent Rectangle",
    className: "cls-2",
    width: 32,
    height: 32
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContourFinding);
export default __webpack_public_path__ + "static/media/contour-finding.bf16da26.svg";
export { ForwardRef as ReactComponent };